import React from "react"
import types from "prop-types"
import SvgSpriteIcon from "shared/SvgSpriteIcon"

const GlobalHeaderNavItemContent = ({
  icon, isActiveTab, title, itemId,
}) => (
  <>
    <SvgSpriteIcon
      iconName={icon}
      svgIdAttribute={isActiveTab ? "active" : ""}
      className="header-icon"
      ariaHidden
    />
    <span id={itemId} aria-hidden>{title}</span>
  </>
)

GlobalHeaderNavItemContent.propTypes = {
  icon: types.string.isRequired,
  isActiveTab: types.bool.isRequired,
  title: types.string.isRequired,
  itemId: types.string.isRequired,
}

export default GlobalHeaderNavItemContent
